import React, { MutableRefObject, useEffect, useRef } from "react";
import tippy from "tippy.js";

import { ImageItem, VideoItem } from ".";

import { ItemType } from "../types";

interface Props {
  setActiveContentRef: (ref: MutableRefObject<HTMLDivElement>) => void;
  swiperContainerRef: MutableRefObject<HTMLDivElement>;
  setActiveDescriptionRef: (ref: MutableRefObject<HTMLDivElement>) => void;
  isLighthboxOpen: boolean;
  isActive: boolean;
  clickedThumbnailIndex: number;
  item: ItemType;
}

const SlideItem = ({
  isActive,
  swiperContainerRef,
  setActiveDescriptionRef,
  isLighthboxOpen,
  item,
  clickedThumbnailIndex,
  // To get content height and set top position of navigation
  setActiveContentRef,
}: Props) => {
  const slideDescriptionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isActive || !slideDescriptionRef?.current) return;

    const tootips = document.getElementsByClassName("js-tooltip ");
    const arr = [].slice.call(tootips);

    arr.forEach((element) => {
      tippy(element, {
        // parse `content` strings as HTML
        allowHTML: true,
        trigger: "click",
        hideOnClick: true,
        interactive: true,
        arrow: true,
        theme: "kb",
      });
    });

    setActiveDescriptionRef(slideDescriptionRef);
  }, [isActive, slideDescriptionRef]);

  return (
    <div className="lightbox__slide-container">
      {item.type === "img" ? (
        <ImageItem data={item} isSlideActive={isActive} setActiveContentRef={setActiveContentRef} />
      ) : (
        <VideoItem
          data={item}
          swiperContainerRef={swiperContainerRef}
          isSlideActive={isActive}
          isLighthboxOpen={isLighthboxOpen}
          shouldPlayOnLoad={clickedThumbnailIndex === item.slidePositionIndex}
          setActiveContentRef={setActiveContentRef}
        />
      )}
      {!!item?.description && (
        <div className="lightbox__description-container" ref={slideDescriptionRef}>
          <div className="row">
            <div className="mx-auto sm:col-14">
              <div
                className="lightbox__description-text"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SlideItem;
